import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./ekycSession.module.scss";
import Images from "assets/Images";
import { APIConstant } from "services/api-constant";

const RejectedEkyc = ({ handleClickOpenViewInterview, RejectedEkyc }) => {

  return (
 <div className={styles.tableContainer}>
    <table className="w-full text-left border">
      <thead>
        <tr className="bg-gray-100">
          <th className="p-2" width="200">
            Topic
          </th>
          <th className="p-2" width="300">
            Date & Time
          </th>
          <th className="p-2" width="200">
            Time Zone
          </th>
          <th className="p-2" width="200">
            Customer
          </th>

          {/* <th className="p-2">Score</th> */}
          <th className="p-2">Status</th>
          <th className="p-2" width="100">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {RejectedEkyc.map((ekyc) => (

          <tr key={ekyc.id} className="border-t">
            <td className="p-2">{ekyc.topic}</td>
            <td className="p-2">{new Date(ekyc.date_time).toLocaleDateString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true, })}</td>
            <td className="p-2">{ekyc.timezone}</td>
            <td className="p-2">Customer &nbsp; {ekyc.status === "Pending" && <a style={{ cursor: 'pointer' }} onClick={() => getCustomerLink(ekyc.ekycLink)}><img src={Images.LINK} alt="Link" width="14" /></a>}</td>
            <td className="p-2" style={{ whiteSpace: "nowrap" }}>{ekyc.status}</td>

            <td className="p-2">
              <ul className={styles.actionIcons}>
                <li>
                  <a
                  title="Minutes Of Meetings">
                    <img src={Images.MEETINGS} alt="View" width="16" />
                  </a>
                </li>
                <li>
                  <a >
                    <img src={Images.VIEW} alt="View" width="16" />
                  </a>
                </li>

              </ul>
            </td>

          </tr>
        ))}
        {
          RejectedEkyc.length == 0 &&
          <tr className="border-t">
            <td className="p-2" colSpan={7} style={{ textAlign: "center" }}>No data available</td>
          </tr>
        }
      </tbody>
    </table>
</div>
  );
};

export default RejectedEkyc;
